import { Type } from "class-transformer";
import { InventoryOutDTO } from "./inventory.out.dto";

export class InstallationOutDTO {
  @Type(() => InventoryOutDTO)
  inventory!: InventoryOutDTO[];
}
